import React from "react"
import PropTypes from "prop-types"

import "./BeautifulBox.less"

const BeautifulBox = ({ label, image, imageClass, onClick, ...style }) => (
  <div
    className={`beautiful-box ${imageClass || ""}`}
    onClick={() => onClick && onClick()}
    style={image ? { backgroundImage: `url("${image}")`, ...style } : { ...style }}
  >
    <label>{label}</label>
  </div>
)

function xor(a, b) {
  return (a && !b) || (!a && b)
}

BeautifulBox.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  imageClass: PropTypes.string,
  image: (props, propName, componentName) => (
    !xor(props[propName], props.imageClass)
      ? new Error(
        `Invalid props supplied to ${componentName}: must supply either "image" or "imageClass"`
      )
      : null
  )
}

export default BeautifulBox



// WEBPACK FOOTER //
// ./src/app/catalogo/components/BeautifulBox.jsx